



































































































































































































































































































































/* General */
import Vue from 'vue'
import DefaultLayout from '@/layouts/default-layout.vue'
import MainContainer from '@/layouts/main-container.vue'
import EntityChildLayout from '@/layouts/entity-child-layout.vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

import mailboxesImg from '@/assets/img/entities/illustration-mailbox-empty-state.png'
import mailboxesImg2x from '@/assets/img/entities/illustration-mailbox-empty-state@2x.png'
import mailboxesImg3x from '@/assets/img/entities/illustration-mailbox-empty-state@3x.png'

/* Helpers */
import LocalStore from '@/helpers/localstore'
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IAttachment } from '@/types/data-objects/attachments'
import {
  IAtMentionUser,
  IConvertedSavedReply,
  IConvosOutputReplyVariableReplacements,
  IPersonWithEmail,
  IPriorityLevelForSelection,
  IStatusForSelection,
  ICreateNewConversationsStatus,
  IJob,
  IJobAssigneeMandate,
} from '@/api/types/response.types'
import { ICreateItemStorage, IJobInfo } from '@/types/data-objects/items'
import { IConvosInputCreate } from '@/api/types/request.types'

/* API */
import FilesAPI from '@/api/modules/files.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'
import ConversationsAPI from '@/api/modules/convos.api'

export default Vue.extend({
  name: 'ConversationCreate',

  components: {
    CardCanvas,
    DefaultLayout,
    MainContainer,
    EntityChildLayout,
  },

  metaInfo: {
    title: 'New Conversation',
  },

  data() {
    return {
      EEntities,
      ColorAssistant,
      RouteAssistant,
      mailboxesImg,
      mailboxesImg2x,
      mailboxesImg3x,

      FilesAPI,
      browser: this.$deviceInfo.getBrowser,
      mailboxName: '',

      // Create new convos check
      newConvosCheck: {} as ICreateNewConversationsStatus,

      // UI controls
      isSubmitting: false,
      pressedCreateAnother: false,

      // Focus controls
      focusSubject: true,
      focusTo: false,

      // Form
      formData: {
        subject: '',
        to: '',
        cc: [],
        message: '',
        assigneeID: null,
        statusID: null,
        priorityID: null,
        dueDate: null,
        listTags: [],
        listWatchersIDs: [],
        listAtMentionIDs: [],
        listFileUploadIDs: [],
        listJobAppointeeMappings: [],
      } as IConvosInputCreate,

      isLoading: false,

      // Options
      attachments: [] as IAttachment[],
      statusOptions: [] as IStatusForSelection[],
      priorityOptions: [] as IPriorityLevelForSelection[],
      assigneesOptions: [] as IPersonWithEmail[],
      tagsOptions: [] as string[],
      watchersOptions: [] as IPersonWithEmail[],
      mentionOptions: [] as IAtMentionUser[],
      savedReplyOptions: [] as IConvertedSavedReply[],
      replySignature: '',

      jobs: [] as IJob[],
      assigneeMandates: [] as IJobAssigneeMandate[],

      // Reply var constants
      replyVar_customerName: '{CustomerName}',
      replyVar_customerFirstName: '{CustomerFirstName}',
      replyVar_customerLastName: '{CustomerLastName}',

      messageHasCustomerName: false,
      messageHasCustomerFirstName: false,
      messageHasCustomerLastName: false,

      replyVariableReplacements: null as IConvosOutputReplyVariableReplacements,
      showReplyVariablesModal: false,
    }
  },

  computed: {
    pickerSize(): string {
      return this.$screen.isTabletOrMobile(this.$mq) ? 'medium' : 'small'
    },
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
    hasJobs(): boolean {
      return this.jobs.length > 0
    },
    currentAssignee(): IPersonWithEmail {
      let result = null
      if (this.hasJobs) {
        /* Manually grab the correct assignee for the emitted task */
        const assigneeMandate = this.assigneeMandates.find(
          am => am.statusID === this.formData.statusID,
        )

        if (assigneeMandate) {
          const appointeeMapping = this.formData.listJobAppointeeMappings.find(
            jam => jam.jobID === assigneeMandate.jobID,
          )
          result = this.assigneesOptions.find(
            ao => ao.id === appointeeMapping.appointeeID,
          )
        }
      } else if (this.formData.assigneeID) {
        result = this.assigneesOptions.find(
          a => a.id === this.formData.assigneeID,
        )
      }
      return result
    },
    currentStatus(): IStatusForSelection {
      if (this.formData.statusID) {
        return this.statusOptions.find(s => s.id === this.formData.statusID)
      }
      return null
    },
    jobInfo(): IJobInfo {
      if (!this.hasJobs) {
        return null
      }

      const jobAppointees = this.jobs.map(j => ({
        job: j,
        appointee: this.getPotentialAssigneeByID(
          this.formData.listJobAppointeeMappings.find(jam => jam.jobID === j.id)
            .appointeeID,
        ),
      }))

      return {
        jobAppointees,
        assigneeMandates: this.assigneeMandates,
        currentAssignee: this.currentAssignee,
        currentStatus: this.currentStatus,
      }
    },
    requiresReplyVarReplacement(): boolean {
      return (
        this.messageHasCustomerName ||
        this.messageHasCustomerFirstName ||
        this.messageHasCustomerLastName
      )
    },
  },

  watch: {
    'formData.subject': {
      handler() {
        this.handleSubjectMessageChange()
      },
    },
    'formData.message': {
      handler() {
        this.handleSubjectMessageChange()
      },
    },
  },

  async created() {
    this.isLoading = true

    try {
      await Promise.all([
        this.fetchMailboxData(),
        this.fetchOptions(),
        this.fetchCreateNewConversationsCheck(),
      ])
      this.hydrateFieldsFromLocalStorage()
      this.defaultRequiredFields()
      this.resetJobAppointeeMappings()
      this.resetWatchers()
    } catch (error) {
      this.$error.emit(error)
    } finally {
      this.isLoading = false
    }
  },

  mounted() {
    // Pre-seed data from the route.params to seed the breadcrumb listing picker title before the API call...
    if (this.$route.params.mailboxName) {
      this.mailboxName = this.$route.params.mailboxName
    }
  },

  methods: {
    handleSubjectMessageChange() {
      const storage = {
        title: this.formData.subject,
        description: this.formData.message,
      } as ICreateItemStorage
      LocalStore.setConvoCreateData(this.mailboxID, storage)
    },

    defaultRequiredFields() {
      this.formData.statusID = this.statusOptions[0].id
      this.formData.priorityID = this.priorityOptions[0].id
    },
    getPotentialAssigneeByID(id?: number): IPersonWithEmail {
      if (id) {
        return this.assigneesOptions.find(ao => ao.id === id)
      }
      return null
    },
    resetJobAppointeeMappings() {
      this.formData.listJobAppointeeMappings = []
      this.jobs.forEach(j => {
        this.formData.listJobAppointeeMappings.push({
          jobID: j.id,
          appointeeID: null,
        })
      })
    },
    async fetchMailboxData() {
      const response = await MailboxesAPI.get_Detail(this.mailboxID)
      this.mailboxName = response.name
      this.replySignature = response.replySignature
    },
    async fetchOptions() {
      const response = await ConversationsAPI.get_FilterOptions(this.mailboxID)

      this.statusOptions = response.listStatuses
      this.priorityOptions = response.listPriorities
      this.watchersOptions = response.listWatchers
      this.assigneesOptions = response.listAssignees
      this.tagsOptions = response.listTags
      this.mentionOptions = response.listAtMentionUsers
      this.savedReplyOptions = response.listSavedReplies

      this.jobs = response.listJobs
      this.assigneeMandates = response.listAssigneeMandates
    },

    async fetchCreateNewConversationsCheck() {
      this.newConvosCheck = await MailboxesAPI.get_CreateNewConversationsCheck(
        this.mailboxID,
      )
    },
    clearLocalStorageData() {
      LocalStore.clearConvoCreateData(this.mailboxID)
    },
    resetWatchers() {
      if (this.formData.listWatchersIDs.length === 0) {
        this.formData.listWatchersIDs = [this.$permissions.loggedInUser.id]
      }
    },
    /* Only persisting for subject and message */
    hydrateFieldsFromLocalStorage() {
      try {
        const savedFormData = LocalStore.getConvoCreateData(this.mailboxID)
        if (savedFormData) {
          this.formData.subject = savedFormData.title.toString()
          // Quill will scrub sql injection
          this.formData.message = savedFormData.description.toString()
        }
      } catch (e) {
        this.clearLocalStorageData()
        this.clearFormFully()
        return
      }
    },

    addFileHandler(files: IAttachment[]) {
      this.attachments = files
      this.formData.listFileUploadIDs = files.map(
        (item: IAttachment) => item.id,
      )
    },

    async removeFileHandler(id: number) {
      try {
        await this.FilesAPI.delete_Delete(id)
        this.attachments = this.attachments.filter(item => item.id !== id)
        this.formData.listFileUploadIDs = this.attachments.map(item => item.id)
      } catch (error) {
        this.$messaging.showGenericError()
      }
    },

    async create(createAnother: boolean) {
      this.clearLocalStorageData()
      this.isSubmitting = true

      try {
        const response = await ConversationsAPI.post_Create(
          this.mailboxID,
          this.formData,
        )

        this.$messaging.showSuccess(response.message)

        if (createAnother) {
          this.clearFormAfterCreation()
          this.scrollToTop()
          // Regrab options in case there were any updates (specifically tags when just adding new ones)
          await this.fetchOptions()
        } else {
          LocalStore.itemDetailBackBtnToRoot = true

          RouteAssistant.goToConversation(
            this.$router,
            this.$route.params.accountId,
            this.mailboxID,
            response.id,
            this.mailboxName,
          )
        }
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isSubmitting = false
      }
    },

    clearFormAfterCreation() {
      this.formData.subject = ''
      this.formData.to = ''
      this.formData.cc = []
      this.formData.message = ''
      this.formData.listAtMentionIDs = []
      this.formData.listFileUploadIDs = []
    },

    clearFormFully() {
      this.formData.subject = ''
      this.formData.to = ''
      this.formData.cc = []
      this.formData.message = ''
      this.formData.assigneeID = null
      this.formData.priorityID = null
      this.formData.statusID = null
      this.formData.dueDate = null
      this.formData.listTags = []
      this.formData.listWatchersIDs = []
      this.formData.listAtMentionIDs = []
      this.formData.listFileUploadIDs = []
      this.formData.listJobAppointeeMappings = []

      // Set watchers to current user
      this.resetWatchers()
      this.resetJobAppointeeMappings()
      this.defaultRequiredFields()

      this.attachments = []

      // Reset focus
      this.refocusSubjectField()
    },

    /**
     * send to home page
     */
    sendToHome() {
      RouteAssistant.goToMailbox(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
        this.mailboxName,
      )
    },

    clearFocuses() {
      this.focusSubject = false
      this.focusTo = false
    },

    refocusSubjectField() {
      this.clearFocuses()
      this.$nextTick(() => {
        this.focusSubject = true
      })
    },

    refocusToField() {
      this.clearFocuses()
      this.$nextTick(() => {
        this.focusTo = true
      })
    },

    handleCancelClick() {
      this.clearLocalStorageData()
      this.sendToHome()
    },

    insertMentions(matches: any) {
      this.formData.listAtMentionIDs = matches
    },

    async validateAndSubmit(createAnother: boolean) {
      this.pressedCreateAnother = createAnother
      let errorMsg

      const subjectRequired = this.formData.subject.trim().length === 0
      const customerRequired = this.formData.to.trim().length === 0

      if (!(subjectRequired || customerRequired)) {
        // Check if reply variables need replacing (from saved replies selection)
        this.setReplyVarReplacementRequirements(this.formData.message)

        if (this.requiresReplyVarReplacement) {
          this.isSubmitting = true
          this.replyVariableReplacements = await ConversationsAPI.get_ReplyVariableReplacements(
            this.mailboxID,
            this.formData.to,
          )
          this.showReplyVariablesModal = true
          this.isSubmitting = false
          return
        }

        this.create(createAnother)
        return
      }

      if (subjectRequired && customerRequired) {
        errorMsg = 'Please enter a subject and "To" email.'
        this.refocusSubjectField()
      } else if (subjectRequired) {
        errorMsg = 'Please enter a subject.'
        this.refocusSubjectField()
      } else {
        errorMsg = 'Please enter a "To" email.'
        this.refocusToField()
      }
      this.$messaging.showError(errorMsg)
      this.scrollToTop()
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    /* Reply variables */
    closeReplyVariablesModal() {
      this.showReplyVariablesModal = false
    },

    setReplyVarReplacementRequirements(message: string) {
      this.messageHasCustomerName = message.includes(this.replyVar_customerName)
      this.messageHasCustomerFirstName = message.includes(
        this.replyVar_customerFirstName,
      )
      this.messageHasCustomerLastName = message.includes(
        this.replyVar_customerLastName,
      )
    },

    async replaceVariablesAndResubmit() {
      this.formData.message = this.formData.message
        .replace('{CustomerName}', this.replyVariableReplacements.customerName)
        .replace(
          '{CustomerFirstName}',
          this.replyVariableReplacements.customerFirstName,
        )
        .replace(
          '{CustomerLastName}',
          this.replyVariableReplacements.customerLastName,
        )
      this.closeReplyVariablesModal()
      // Need to add this or else local storage doesn't clear (for some reason), in the create() method.
      await this.$nextTick()
      // this.pressedCreateAnother is carried over from the original submission...
      await this.validateAndSubmit(this.pressedCreateAnother)
    },
  },
})
